import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyPln'
})

export class CurrencyPlnPipe implements PipeTransform {
    transform(value: string, args: any[]): any {
        var n = 0;
        var x = 3;
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        var valueInt = parseInt(value);
        // var valueInt = parseInt(value) * Math.random()*10;
        return valueInt.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$& ');
        // return value + ' pipe';
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/currencyPLN.pipe.ts